<template>
  <a-select
    show-search
    :value="value"
    placeholder="Select Biller"
    style="width: 100%"
    :filterOption="false"
    :default-active-first-option="false"
    :show-arrow="true"
    :not-found-content="null"
    @search="fetchBillers"
    @change="handleChange">
    <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
    <a-select-option v-for="d in data" :key="d.hash" :value="d.name">
      {{ d.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "single-biller-autocomplete",
  props: {
    currentValue: {
      type: String
    }
  },
  data() {
    this.fetchBillers = _.debounce(this.fetchBillers, 800)

    return {
      data: [],
      value: this.currentValue,
      fetching: false
    }
  },
  mounted() {
    this.fetchBillers()
  },
  methods: {
    fetchBillers(value) {
      this.data = []
      this.fetching = true
      this.$http.get(this.routeUri('hyperion.biller'), {
        params: {q: value}
      })
        .then((response) => this.data = response.data.data)
        .finally(() => this.fetching = false)
    },
    handleChange(value) {
      this.$emit('change', _.filter(this.data, (o) => o.name === value)[0])

      Object.assign(this, {
        value,
        data: [],
        fetching: false
      })
    }
  }
}
</script>

<style scoped>

</style>
